export function FulfilledIcon({ color = '#017F5C' }) {
  return (
    <svg
      width="12"
      height="11"
      viewBox="0 0 12 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="mr-2"
    >
      <circle cx="6" cy="5.5" r="4" fill={color} />
    </svg>
  )
}
